<template>
    <div class="live-data-container">
      <!-- 顶部标题 -->
      <div class="page-header">
        <h1 class="page-title">探访工厂统计中心</h1>
      </div>
  
      <!-- 账单查看 -->
      <div class="bill-view-section">
        <div class="bill-view-header">
          <span class="section-title">账单查看</span>
          <el-date-picker
            v-model="selectedMonth"
            type="month"
            placeholder="选择月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="onMonthChange"
            class="month-picker"
          />
          <span class="bill-description">按计费周期</span>
         
          <div class="balance-section">
                当前余额:{{ overview.balance || '0.00' }}元
                <el-button size="small" @click="goToRechargeRecord">充值记录</el-button>
          </div>
        </div>
      </div>
  
      <!-- 主要内容区域 -->
      <div class="main-content">
        <!-- 左侧：账单概览 -->
        
        <div class="overview-section">
         
          <div class="overview-card">
            <div class="overview-title">账单概览</div>
            <div class="date-view">
              <div class="month-circle">
                  <div class="month-text">{{ overview.month_display || '--' }}</div>
              
              </div>
              <div class="date-separator">
                  <div class="year-text">{{ overview.year_month || '--' }}</div>
                  <div class="period-text">统计周期:按计费周期</div>
              </div>

              
             
          </div>
            
            
            <div class="total-cost-label">总费用</div>
            <div class="total-cost-value">{{ overview.total_cost || '0.00' }}</div>
            
          </div>
        </div>
  
        <!-- 右侧：费用趋势 -->
        <div class="trend-section">
          <div class="trend-card">
            <div class="trend-header">
              <span class="trend-title">费用趋势</span>
              <span class="trend-unit">费用:元</span>
              <div class="period-buttons">
                <button 
                  class="period-btn" 
                  :class="{ active: period === 'half_year' }"
                  @click="switchPeriod('half_year')"
                >
                  近半年
                </button>
                <button 
                  class="period-btn" 
                  :class="{ active: period === 'year' }"
                  @click="switchPeriod('year')"
                >
                  近一年
                </button>
              </div>
            </div>
            <div class="chart-container" ref="trendChart"></div>
          </div>
        </div>
      </div>
  
     
    </div>
  </template>
  
  <script>
  import common from '@/utils/common';

  
  export default {
    name: 'LiveData',
    data() {
      return {
        selectedMonth: new Date().toISOString().slice(0, 7), // 格式：2025-10
        period: 'half_year', // half_year 或 year
        overview: {
          month: '',
          month_display: '',
          year_month: '',
          total_cost: 0,
          duration: 0
        },
        trend: [],
        details: [],
        trendChart: null,
        displayLimit: 10 // 默认显示10条
      }
    },
    computed: {
      displayDetails() {
        if (!this.details || this.details.length === 0) {
          return [];
        }
        return this.details.slice(0, this.displayLimit);
      }
    },
    created() {
      this.loadData();
    },
    mounted() {
      this.initChart();
    },
    beforeDestroy() {
      if (this.trendChart) {
        this.trendChart.dispose();
      }
    },
    methods: {
      // 加载数据
      loadData() {
        const params = {
          month: this.selectedMonth,
          period: this.period
        };
       
        common.connect('/distributorpcv1/jiaofu/live_data', params, (res) => {
          this.overview = res.data.overview || {};
          this.trend = res.data.trend || [];
       
          this.updateChart();
        });
      },
      
      // 月份变化
      onMonthChange() {
        this.loadData();
      },
      
      // 切换时间段
      switchPeriod(p) {
        this.period = p;
        this.loadData();
      },
      
      // 初始化图表
      initChart() {
        if (!this.$refs.trendChart) return;
        
        
        this.trendChart = this.$echarts.init(this.$refs.trendChart);
        this.updateChart();
        
        // 响应式调整
        window.addEventListener('resize', () => {
          if (this.trendChart) {
            this.trendChart.resize();
          }
        });
      },
      
      // 更新图表
      updateChart() {
        if (!this.trendChart || !this.trend || this.trend.length === 0) return;
        
        const months = this.trend.map(item => {
          const arr = item.month.split('-');
          return arr[0] + '-' + arr[1];
        });
        const costs = this.trend.map(item => item.cost);
        
        // 计算Y轴最大值（向上取整到最近的100）
        const maxCost = Math.max(...costs, 100);
        const yMax = Math.ceil(maxCost / 100) * 100;
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function(params) {
              return params[0].name + '<br/>费用: ' + params[0].value.toFixed(2) + ' 元';
            }
          },
          grid: {
            left: '10%',
            right: '10%',
            top: '15%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            data: months,
            axisLine: {
              lineStyle: {
                color: '#333'
              }
            },
            axisLabel: {
              color: '#333',
              fontSize: 12
            }
          },
          yAxis: {
            type: 'value',
            max: yMax,
            interval: yMax / 6,
            axisLine: {
              lineStyle: {
                color: '#333'
              }
            },
            axisLabel: {
              color: '#333',
              fontSize: 12,
              formatter: function(value) {
                return Math.round(value);
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.1)'
              }
            }
          },
          series: [{
            name: '费用',
            type: 'bar',
            data: costs,
            itemStyle: {
              color: '#3b82f6'
            },
            label: {
              show: true,
              position: 'top',
              color: '#333',
              fontSize: 11,
              formatter: function(params) {
                return params.value.toFixed(2);
              }
            }
          }]
        };
        
        this.trendChart.setOption(option);
      },
      
      // 显示更多详情 - 跳转到详情页面
      showMoreDetails() {
        this.$router.push({
          path: '/jiaofu/LiveDataDetail',
          query: { 
            month: this.selectedMonth 
          }
        });
      },
      
      // 跳转到充值记录页面
      goToRechargeRecord() {
       
          this.$router.push({
            path: '/jiaofuLiveRechargeRecord'
          });
      }
    }
  }
  </script>
  
  <style scoped>
  .live-data-container {
    min-height: 100vh;
    background: #f0f0f0;
    color: #333;
    font-family: 'Microsoft YaHei', sans-serif;
    padding: 20px;
  }
  
  .page-header {
    margin-bottom: 30px;
  }
  
  .page-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin: 0;
    border-left: 4px solid #3b82f6;
    padding-left: 10px;
  }
  
  /* 账单查看部分 */
  .bill-view-section {
    margin-bottom: 30px;
    background-color: #fff;
    padding:10px;
  }
  
  .bill-view-header {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
    
    
  }
  
  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  
  .month-picker {
    width: 150px;
  }
  
  .bill-description {
    font-size: 12px;
    color: #666;
    
  }
  
  /* 主要内容区域 */
  .main-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  /* 账单概览 */
  .overview-section {
    display: flex;
  }
  
  .overview-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 30px;
    border: 1px solid #e0e0e0;
    width: 100%;
    
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .overview-title {
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-bottom: 20px;
  }
  
  .date-view {
    display: inline-flex;
    
    align-items: center;
    justify-content: center;
  }
  
  .date-separator {
    margin-left: 20px;
  }
  
  .month-circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: blue;
    border: 2px solid #3b82f6;
    
    display: flex;
    
    align-items: center;
    justify-content: center;
  }
  
  .month-text {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 5px;
  }
  
  .year-text {
    font-size: 20px;
    color: #333;
  }
  
  .period-text {
    font-size: 12px;
    color: #666;
    margin-bottom: 20px;
  }
  
  .total-cost-label {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
    margin-top: 30px;
  }
  
  .total-cost-value {
    font-size: 48px;
    font-weight: bold;
    color: #333;
    
  }
  
  .cost-description {
    font-size: 11px;
    color: #666;
    line-height: 1.6;
    text-align: left;
    margin-top: 6px;
    background-color: #eee;
    padding:16px;
  }
  
  /* 费用趋势 */
  .trend-section {
    display: flex;
  }
  
  .trend-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #e0e0e0;
    width: 100%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .trend-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .trend-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  
  .trend-unit {
    font-size: 12px;
    color: #666;
    margin-left: 10px;
  }
  
  .period-buttons {
    display: flex;
    gap: 10px;
    margin-left: auto;
  }
  
  .period-btn {
    background: #f5f5f5;
    border: 1px solid #e0e0e0;
    color: #333;
    padding: 6px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.3s;
  }
  
  .period-btn:hover {
    background: #e8e8e8;
  }
  
  .period-btn.active {
    background: #3b82f6;
    border-color: #3b82f6;
    color: #fff;
  }
  
  .chart-container {
    width: 100%;
    height: 300px;
  }
  
  /* 账单明细 */
  .details-section {
    margin-top: 20px;
  }
  
  .details-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .details-header {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  
  .details-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  
  .sort-hint {
    font-size: 12px;
    color: #666;
  }
  
  .more-link {
    font-size: 12px;
    color: #3b82f6;
    cursor: pointer;
    margin-left: auto;
    text-decoration: underline;
  }
  
  .more-link:hover {
    color: #60a5fa;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .details-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }
  
  .details-table thead {
    background: #f5f5f5;
  }
  
  .details-table th {
    padding: 12px 8px;
    text-align: left;
    color: #333;
    font-weight: 500;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .details-table td {
    padding: 12px 8px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .details-table tbody tr:hover {
    background: #f9f9f9;
  }
  
  .no-data {
    text-align: center;
    color: #999;
    padding: 30px !important;
  }
  
  .recharge-btn {
    background: #3b82f6;
    color: #fff;
    border: none;
    padding: 4px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.3s;
  }
  
  .recharge-btn:hover {
    background: #2563eb;
  }
  
  /* Element UI 日期选择器样式覆盖 */
  ::v-deep .el-date-editor.el-input {
    width: 150px;
  }
  
  ::v-deep .el-input__inner {
    background: #ffffff !important;
    border: 1px solid #e0e0e0 !important;
    color: #333 !important;
  }
  
  ::v-deep .el-input__inner::placeholder {
    color: #999 !important;
  }
  
  ::v-deep .el-input__icon {
    color: #666 !important;
  }
  
  /* 响应式设计 */
  @media (max-width: 1200px) {
    .main-content {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 768px) {
    .live-data-container {
      padding: 10px;
    }
    
    .page-title {
      font-size: 24px;
    }
    
    .bill-view-header {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .bill-description {
      margin-left: 0;
    }
    
    .total-cost-value {
      font-size: 36px;
    }
    
    .chart-container {
      height: 250px;
    }
    
    .details-table {
      font-size: 11px;
    }
    
    .details-table th,
    .details-table td {
      padding: 8px 4px;
    }
  }
  .balance-section {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    flex:1;
    justify-content: flex-end;
  }
 
  </style>
  